import { BOG_LINE_GAME_TYPES, isMobile } from '@pascal/pascal-core';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { userSettingsStore } from '@pascal/pascal-core/shared/core/store/userSettingsStore';

import { gameName } from '../../enums/gameConfigsAndUrls';
import { soundService } from '../../services/SoundService';
import { resizeGameHandler } from '../../helpers/resizeGame';
import { specificLocalStorageKeys } from '../../enums/constants';
import { gameLiveConnection, gameService, registerApis } from '../../services';
import { liveConnection } from '../liveConnection';
import { gameStore } from '../../store/gameStore';

export const init = () => {
  if (isMobile()) {
    document.documentElement.classList.add('is-mobile');
  } else {
    resizeGameHandler();
    window.addEventListener('resize', resizeGameHandler);
    document.documentElement.classList.add('is-web');
  }

  userSettingsStore.localStorageAndUserSettingsInit({
    gameName,
    gameService,
    soundService,
    liveConnection,
    gameLiveConnection,
    gameSpecificData: {
      [specificLocalStorageKeys.isTurboModePopUp]: false,
    },
  });
  registerApis();
  gameConfigStore.initGameConfigs(
    {
      sectionCount: 1,
      bogLineGameTypeData: {
        gameType: BOG_LINE_GAME_TYPES.ONLY_MARKET,
        isUsedPlatformIntegrationLogic: true,
        isUsedStakeUpdateLogic: true,
      },
      isUsedBogLineComponents: false,
      initPlatformMessageConfigs: false,
      isAllSectionWithCashOutButton: false,
      isUsedInputValidationFunctionality: false,
      isUsedRoundStartAndFinishedLogicAfterCashOut: false,
    },
    {
      isGameHasPixi: true,
      onFreeBetActivateCallback: () => {
        gameStore.setIsFreeBetActivatedFromToggle(true);
      },
    }
  );
};
